import { Crown, Rocket, Star, Building2, Zap } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { PlanType, PLAN_LIMITS } from '@/lib/plan-limits';
import { cn } from '@/lib/utils';

interface PlanBadgeProps {
  plan: PlanType;
  className?: string;
  showIcon?: boolean;
}

const planIcons: Record<PlanType, React.ReactNode> = {
  free: <Zap className="h-3 w-3" />,
  starter: <Rocket className="h-3 w-3" />,
  professional: <Star className="h-3 w-3" />,
  business: <Crown className="h-3 w-3" />,
  enterprise: <Building2 className="h-3 w-3" />,
};

const planVariants: Record<PlanType, string> = {
  free: 'bg-muted text-muted-foreground border-muted-foreground/20',
  starter: 'bg-blue-500/10 text-blue-600 dark:text-blue-400 border-blue-500/20',
  professional: 'bg-purple-500/10 text-purple-600 dark:text-purple-400 border-purple-500/20',
  business: 'bg-amber-500/10 text-amber-600 dark:text-amber-400 border-amber-500/20',
  enterprise: 'bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border-emerald-500/20',
};

export function PlanBadge({ plan, className, showIcon = true }: PlanBadgeProps) {
  const planInfo = PLAN_LIMITS[plan];

  return (
    <Badge 
      variant="outline" 
      className={cn(
        'font-medium',
        planVariants[plan],
        className
      )}
    >
      {showIcon && <span className="mr-1">{planIcons[plan]}</span>}
      {planInfo.displayName}
    </Badge>
  );
}
